import { useActionState, useEffect, useRef, useState } from "react";
import Select from "../../../../components/select";
import { GreetingOccasionImage, OccasionCollection } from "../../../../models";
import { setOccasionCollection } from "../actions";
import toast from "react-hot-toast";

export default function OccasionCollectionSelector({image,occasionCollections,onSuccess}:{image:GreetingOccasionImage,occasionCollections:OccasionCollection[],onSuccess:(image:GreetingOccasionImage)=>void}){
    const formRef = useRef<HTMLFormElement>(null);
    const [selectedId, setSelectedId] = useState(
        image.occasionCollectionId?.toString() ?? ""
    );
    const setOccasionCollectionWithId = setOccasionCollection.bind(null, image.id||0);
    const [state, formAction, isPending] = useActionState(setOccasionCollectionWithId, {
        message: null,
        success: false,
        errors: {},
    });

    useEffect(() => {
        setSelectedId(image.occasionCollectionId?.toString() ?? "");
    }, [image.id, image.occasionCollectionId]);

    useEffect(() => {
        if (state.success) {
            toast.success(state.message);
            onSuccess(image);
        }
    }, [state]);

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        setSelectedId(value);
        image.occasionCollectionId = value ? parseInt(value, 10) : undefined;
        formRef.current?.requestSubmit();
    };

    return (
        <form ref={formRef} action={formAction}   className="w-full">
            <Select
                className="w-full"
                name="occasionCollectionId"
                value={selectedId}
                onChange={handleChange}
                disabled={isPending}
                items={occasionCollections.map((occasionCollection) => ({
                    id: occasionCollection.id,
                    name: occasionCollection.name,
                }))}
            />
        </form>
    );
}